import { render } from "./ic-card.vue?vue&type=template&id=45bcb45a&ts=true"
import script from "./ic-card.vue?vue&type=script&lang=ts"
export * from "./ic-card.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__